<script setup>
const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  labelFor: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  invalidFeedback: {
    type: String,
    default: ''
  },
  validFeedback: {
    type: String,
    default: ''
  },
  infoText: {
    type: String,
    default: ''
  },
  state: {
    type: Boolean
  }
})
</script>

<template>
  <fieldset
    class="tasty-form-group"
    :class="{ disabled }"
  >
    <slot name="label">
      <div class="d-flex">
        <label
          v-if="props.label"
          :for="props.labelFor || props.label"
          class="tasty-form-group-label"
          >{{ props.label }}</label
        >
        <info-tooltip
          v-if="props.infoText"
          :title="props.infoText"
          class="tasty-form-group-info"
        />
      </div>
    </slot>
    <slot
      :id="props.labelFor || props.label"
      name="default"
      :disabled="props.disabled"
    ></slot>

    <span
      v-if="props.state === false && props.invalidFeedback"
      class="d-block mt-2 tasty-form-group-feedback tasty-form-group-feedback-invalid"
      >{{ props.invalidFeedback }}</span
    >
    <span
      v-if="props.state === true && props.validFeedback"
      class="d-block mt-2 tasty-form-group-feedback tasty-form-group-feedback-valid"
      >{{ props.validFeedback }}</span
    >

    <span
      v-if="props.description || $slots.description"
      class="d-block mt-2 tasty-form-group-description"
    >
      <slot name="description">
        {{ props.description }}
      </slot>
    </span>
  </fieldset>
</template>

<style lang="scss" scoped>
.tasty-form-group {
  margin-bottom: 1rem;
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
